import React from "react";
import i18n from "i18next";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { api } from "@/utils/api";
import ConfirmBody from "@/react-components/Confirm/Body";
import ConfirmDiffBody from "@/react-components/Confirm/DiffBody";
import ConfirmUpdateTips from "@/react-components/Confirm/Update/Tips";
import { agreementStatusEnum } from "@/utils/enum";

class ConfirmUpdateInquiry extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: null, isFuture: false };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    api.agreement
      .getLoginInquiry({ isSubUser: false })
      .then((response) => {
        if (response?.list && response?.list?.length > 0) {
          this.setState(
            {
              data: {
                content: response?.list[0],
                secureToken: response?.secureToken,
              },
            },
            () => {
              this.fetchTime();
            }
          );
        } else {
          const { updateStatus } = this.props;
          updateStatus && updateStatus(agreementStatusEnum.inquiryUpdated);
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  fetchTime = () => {
    const { data } = this.state;
    const content = data?.content;
    if (content) {
      api.common
        .getTime()
        .then((response) => {
          const isFuture =
            moment(content?.updateDate).format("YYYYMMDD") >
            moment(response).format("YYYYMMDD");
          const { updateStatus } = this.props;
          updateStatus &&
            updateStatus(agreementStatusEnum.inquiryWillUpdate, isFuture);
          this.setState({ isFuture });
        })
        .catch((error) => {
          console.error("error: " + error.message);
        });
    }
  };

  next = () => {
    const { data } = this.state;
    const { authentication } = this.props;
    const content = data?.content;
    api.agreement
      .updateLoginInquiry({
        userid: authentication?.accountId,
        secureToken: data?.secureToken,
        version: content?.version,
      })
      .then((response) => {
        const { updateStatus } = this.props;
        updateStatus && updateStatus(agreementStatusEnum.inquiryUpdated);
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  close = () => {
    const { updateStatus } = this.props;
    updateStatus && updateStatus(agreementStatusEnum.inquiryUpdated);
  };

  header = () => {
    const { isFuture, data } = this.state;
    const content = data?.content;
    return (
      <ConfirmUpdateTips
        className="confirm-update-inquiry-container-tips"
        text={
          isFuture
            ? moment(content?.updateDate).format(
                i18n.t("TCCs0031_confirm_update_inquiry_future_tips")
              )
            : i18n.t("TCCs0031_confirm_update_inquiry_tips")
        }
      />
    );
  };

  render() {
    const { data, isFuture } = this.state;
    const content = data?.content;
    return (
      <div className="confirm-update-inquiry-container">
        {this.header()}
        {content ? (
          <React.Fragment>
            <ConfirmDiffBody
              className="confirm-update-inquiry-container-diff-body"
              title={i18n.t("TCCs0031_confirm_update_inquiry_diff_title")}
              data={content}
              showExpand={true}
              // 課金-ADD-START
              downloadUrl={i18n.t("inquiry_diff_version_download_url")}
              // 課金-ADD-END
            />
            <ConfirmBody
              className="confirm-update-inquiry-container-body"
              title={i18n.t("TCCs0031_confirm_update_inquiry_content_title")}
              confirmButtonText={i18n.t(
                "TCCs0031_confirm_update_inquiry_button_title"
              )}
              content={content?.contentText}
              onClick={this.next}
              // 課金-ADD-START
              date={moment(content.updateDate).format(
                i18n.t("common_date_after")
              )}
              downloadUrl={i18n.t("inquiry_applicable_version_download_url")}
              // 課金-ADD-END
              showCheckbox={false}
              showCloseButton={isFuture}
              onClose={this.close}
            />
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

ConfirmUpdateInquiry.propTypes = {
  updateStatus: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    state: state?.user?.authState,
    authentication: state?.user?.authentication,
  };
};

export default connect(mapStateToProps)(ConfirmUpdateInquiry);
